import {Pipe, PipeTransform} from "@angular/core";
import {QuestionGroup, QuestionGroupType} from "../../store/state/checklist-common";

@Pipe({
    name: 'toGroupName',
    standalone: false
})
export class ToGroupNamePipe implements PipeTransform {

	private readonly NAME_MAP: Map<QuestionGroupType, string> = new Map<QuestionGroupType, string>();

	constructor() {
		this.NAME_MAP.set(QuestionGroupType.APPLICANT_SCOPE_AND_OUTSOURCING, 'Applicant Scope and Outsourcing');
		this.NAME_MAP.set(QuestionGroupType.CONFIDENTIALITY_AND_IMPARTIALITY, 'Confidentiality and Impartiality');
		this.NAME_MAP.set(QuestionGroupType.AUDIT_TEAM, 'Audit Team');
		this.NAME_MAP.set(QuestionGroupType.AUDIT_TIME, 'Audit Time');
		this.NAME_MAP.set(QuestionGroupType.ADDITIONAL, 'Additional');
		this.NAME_MAP.set(QuestionGroupType.RENEWAL_CHECKLIST, 'Checklist');
	}

	transform(questionGroup: QuestionGroup): string {
		return this.NAME_MAP.get(questionGroup.type);
	}
}
